import Icon from '../components/Icon.vue'

Icon.register({
  random: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505 359c9.4 9.4 9.4 24.6 0 33.9l-80 80c-15 15-41 4.5-41-17v-40h-58.8c-2.9 0-6.8-1.7-8.8-3.8l-70.6-75.6 53.3-57.1 52.8 56.6h32v-40c0-21.4 25.9-32 41-17zM12 176c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h110.8 0c2.9 0 6.8 1.7 8.8 3.8l70.6 75.6-53.3 57.1-52.8-56.6h-84zM384 176h-32l-220.4 236.2c-2.3 2.4-5.4 3.8-8.8 3.8h-110.8c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h84l220.4-236.2c2-2.1 5.9-3.8 8.8-3.8h58.8v-40c0-21.4 25.9-32 41-17l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-15 15-41 4.5-41-17v-40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/random.js
// module id = 1678
// module chunks = 0